import { FormGroup } from "carbon-components-react";
import React from "react";

const ApplicationDisclaimer = () => {
  return (
    <FormGroup legendText="" className="section-header">
      <div className="content">
        <h4>Utilização de dados</h4>
        <p>
          Esta secção descreve a forma como recolhemos, utilizamos e protegemos
          os seus dados no âmbito do FlowNegócios na componente referente ao
          concurso para o desenvolvimento de Projectos Moz. Ao inscrever-se
          neste concurso, o utilizador concorda com os seguintes termos:
        </p>

        <p>
          <strong>1. Recolha de dados:</strong> Nós recolhemos dados pessoais
          quando se inscreve no concurso. Estes dados podem incluir o seu nome,
          detalhes de contacto, informações comerciais e quaisquer outras
          informações necessárias para fornecer os nossos serviços.
        </p>

        <p>
          <strong>2. Objetivo da recolha de dados:</strong> Os dados pessoais
          que recolhemos são utilizados para os seguintes finalidades:
          tramitação da sua inscrição e para comunicar consigo relativamente à
          sua participação e fornecer atualizações ou informações relacionadas
          com o concurso.
        </p>

        <p>
          <strong>3. Proteção de dados:</strong> Nós implementamos medidas
          técnicas e organizacionais adequadas para proteger os seus dados
          pessoais contra o acesso não autorizado, alteração, divulgação ou
          destruição. Isto inclui sistemas de armazenamento seguro, encriptação
          e controlos de acesso.
        </p>

        <p>
          <strong>4. Partilha de dados:</strong> Nós não partilhamos os seus
          dados pessoais com terceiros, excepto quando necessário para fins do
          Projecto ou conforme exigido por lei. Quando a partilha de dados é
          necessária, garantimos que estão em vigor salvaguardas adequadas para
          proteger as suas informações.
        </p>

        <p>
          <strong>5. Retenção de dados:</strong> Conservamos os seus dados
          pessoais durante o tempo necessário para cumprir as finalidades do
          Projecto FlowNegócios. Quando os seus dados já não forem necessários,
          serão eliminados ou tornados anónimos de forma segura.
        </p>

        <p>
          <strong>6. Informações de contacto:</strong> Se tiver quaisquer
          questões ou preocupações sobre as nossas práticas de utilização de
          dados ou se pretender exercer os seus direitos, contacte-nos através
          de <a href="mailto:info@ologa.com">info@ologa.com</a>.
        </p>

        <p>
          Ao inscrever-se neste concurso, o candidato reconhece que leu,
          compreendeu e concordou com a presente política de utilização de
          dados.
        </p>
      </div>
    </FormGroup>
  );
};

export default ApplicationDisclaimer;
